// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Util
import { hasCommandModifier } from '../../../utils/keyboard/keyboardUtility';
import { buildUrl } from '../../../../common/utils/urlUtil';
import { navigateToBoard } from '../../../reducers/navigationActions';

// Components
import EllipsisAnimation from '../../../components/animations/EllipsisAnimation';
import Icon from '../../../components/icons/Icon';

// Styles
import './HeaderBackButtonHybrid.scss';

const getBreadcrumbIds = (state, ownProps) => {
    return ownProps.breadcrumbObj.path || [];
};

const mapDispatchToProps = (dispatch) => ({
    dispatchNavigateToBoard: (boardId, keepSelection, newTab) =>
        dispatch(navigateToBoard({ boardId, keepSelection, newTab })),
});

const mapStateToProps = createStructuredSelector({
    breadcrumbIds: getBreadcrumbIds,
});

const HeaderBackButtonHybrid = ({
    breadcrumbIds,
    currentBoardId,
    rootBoardId,
    dispatchNavigateToBoard,
    closestPermissionId,
}) => {
    if (breadcrumbIds.length === 0) {
        return (
            <div className="HeaderBackButtonHybrid">
                <EllipsisAnimation />
            </div>
        );
    }

    const parentId = breadcrumbIds[breadcrumbIds.length - 2] ?? rootBoardId ?? 'login';

    const linkURL = buildUrl(`/${parentId}`, {
        p: closestPermissionId,
    });

    const handleNavigateToBoard = (event) => {
        event.preventDefault();

        if (currentBoardId === parentId) return;

        dispatchNavigateToBoard(parentId, false, hasCommandModifier(event));
    };

    return (
        <div className="HeaderBackButtonHybrid">
            <a className="HeaderBackButtonLink" href={linkURL} onClick={handleNavigateToBoard}>
                <Icon name="chevron-left-large" />
            </a>
        </div>
    );
};

HeaderBackButtonHybrid.propTypes = {
    rootBoardId: PropTypes.string,
    breadcrumbIds: PropTypes.array,
    currentBoardId: PropTypes.string,
    breadcrumbObj: PropTypes.object,
    dispatchNavigateToBoard: PropTypes.func,
    closestPermissionId: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBackButtonHybrid);
